import { Pipe, PipeTransform } from '@angular/core';

import { DBM_RANGES } from '../../shared/models/dbmRange.model';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateWifiStrength',
})
export class TranslateWifiStrengthPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: number): string {
    if (value !== undefined && this.customTranslationsService.WIFI_STRENGTH[this.strength(value)]) {
      return this.translateService.instant(
        this.customTranslationsService.WIFI_STRENGTH[this.strength(value)] ?? this.strength(value)
      );
    }

    return '';
  }

  private strength(strengthValue: number): string {
    const strengthRaw = strengthValue ? strengthValue : null;

    if (!strengthRaw || isNaN(strengthRaw)) {
      return 'off';
    }

    const dbmRange = DBM_RANGES.find((range) => this.isInRange(strengthRaw, range.from, range.to));

    return dbmRange ? dbmRange.strength : 'off';
  }

  private isInRange(n: number, start: number, end: number): boolean {
    return n <= start && n > end;
  }
}
